import { ReactNode } from 'react';
import { Modal } from 'antd';

type Props = {
  title?: string;
  isModalOpen: boolean;
  handleCancel: () => void;
  handleOk?: () => void;
  closeIcon?: boolean;
  children: ReactNode;
  width?: number;
  destroyOnClose?: boolean;
};

const CommonModal = ({
  title,
  isModalOpen,
  handleCancel,
  handleOk,
  children,
  closeIcon = true,
  width,
  destroyOnClose,
}: Props) => {
  return (
    <Modal
      title={title}
      open={isModalOpen}
      onOk={handleOk ?? handleCancel}
      onCancel={handleCancel}
      width={width || 720}
      footer={null}
      centered
      closeIcon={closeIcon}
      destroyOnClose={destroyOnClose}
    >
      {children}
    </Modal>
  );
};

export default CommonModal;
